<template>
  <ul class="px-[10px]">
    <MetadataCard
      v-for="value in metadatas.items"
      :key="value.id"
      :metadata="value" />
  </ul>
</template>

<script>
import MetadataCard from '@/components/common/MetadataCard.vue';

export default {
  name: 'AllMetadatasList',
  components: {
    MetadataCard,
  },
  props: {
    metadatas: {
      type: Object,
      default: () => ({ items: [] })
    }
  }
}
</script>

<style scoped>
/* Component styles are handled by Tailwind classes */
</style>
